import React from 'react';
import { useNode } from '@craftjs/core';
import { Box } from '@mui/material';

export const ImageSettings = () => {
  const {
    actions: { setProp },
    src,
    alt,
    width,
    height,
    borderRadius,
  } = useNode((node) => ({
    src: node.data.props.src,
    alt: node.data.props.alt,
    width: node.data.props.width,
    height: node.data.props.height,
    borderRadius: node.data.props.borderRadius,
  }));

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <label>URL изображения</label>
        <input
          type="text"
          value={src}
          onChange={(e) => setProp((props) => (props.src = e.target.value))}
          placeholder="https://example.com/image.jpg"
          style={{ width: '100%', padding: '8px' }}
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Альтернативный текст</label>
        <input
          type="text"
          value={alt}
          onChange={(e) => setProp((props) => (props.alt = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Ширина (px)</label>
        <input
          type="number"
          value={width}
          onChange={(e) => setProp((props) => (props.width = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Высота (px)</label>
        <input
          type="number"
          value={height}
          onChange={(e) => setProp((props) => (props.height = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Скругление углов (px)</label>
        <input
          type="number"
          value={borderRadius}
          onChange={(e) => setProp((props) => (props.borderRadius = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        />
      </Box>
    </Box>
  );
};

export const Image = ({ src, alt, width, height, borderRadius }) => {
  const {
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <Box
      ref={(ref) => connect(drag(ref))}
      sx={{
        p: 1,
        border: selected ? '2px solid #00ACC1' : '2px solid transparent',
        cursor: 'move',
        display: 'inline-block',
        '&:hover': {
          border: '2px dashed #00ACC1',
        },
      }}
    >
      <img
        src={src || '/img/1.jpg'}
        alt={alt}
        style={{
          width: width ? `${width}px` : 'auto',
          height: height ? `${height}px` : 'auto',
          maxWidth: '100%',
          borderRadius: `${borderRadius}px`,
        }}
      />
    </Box>
  );
};

Image.craft = {
  props: {
    src: '',
    alt: 'Изображение',
    width: 400,
    height: 300,
    borderRadius: 0,
  },
  related: {
    settings: ImageSettings,
  },
};
